<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Body_Text"><span><span style=" font-family: DirtyEgo; font-size: 8.42em;">FROSTBITE</span></span></p>
<p class="P_Body_Text"><span> </span></p>
<p class="P_Body_Text"><span><span style=" font-family: BigNoodleTitling; font-size: 1.67em;">Modern Knights</span></span></p>
<div style="text-align:center; width:100%;">
<div class="P_Body_Text" style=" width: 38.90mm; height: 48.30mm; max-width: 100%; max-height: 100%; display:inline-block;"><span><img alt="" src="image0.jpg" style=" width: 100%;"/></span></div>
</div>
<p class="P_Body_Text"><span><span style=" font-family: BigNoodleTitling; font-size: 1.67em;">Book One</span></span></p>
<p class="P_Body_Text"><span> </span></p>
<p class="P_Body_Text"><span><span style=" font-family: DirtyEgo; font-size: 6.00em;">JOSHUA BADER</span></span></p>
<p class="P_Body_Text"><span> </span></p>
<p class="P_Body_Text"><span> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?5a2612bf